import * as bus from "@sinch/bus";
import { MFECatalog } from "@sinch/mfe-loader";

const unsub = bus.listen(async (message) => {
  if (bus.isData(message)) {
    const { name } = message.payload;
    const mfeConfigEntry = MFECatalog.mfeConfig[name];

    if (mfeConfigEntry && mfeConfigEntry.url) {
      bus.sendLocal(
        bus.mfeConfigMessage({
          name,
          ...mfeConfigEntry,
        })
      );
    } else {
      console.error(
        `Couldn't retrieve MFE info, ${name} not in Config or url is missing.`
      );
    }
  }
}, bus.isMfeConfigRequestMessage);

window.addEventListener("unload", unsub); // guess not needed actually
